export default {
  box: 'Box',
  prio: 'Priorität',
  comment: 'Kommentar',
};
